import { motion } from "framer-motion";
import { SEOHead } from "@/components/shared/SEOHead";

export default function DatenschutzPage() {
  return (
    <div className="pt-24 pb-20">
      <SEOHead
        title="Datenschutzerklärung | Freitag-Gruppe Braunschweig"
        description="Datenschutzerklärung der Freitag-Gruppe. Informationen zur Datenverarbeitung gemäß DSGVO."
        canonical="/datenschutz"
        noindex={true}
      />
      <div className="container-wide">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl"
        >
          <div className="w-12 h-1 gradient-blue mb-8" />
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-foreground mb-12">
            {"Datenschutzerkl\u00e4rung"}
          </h1>

          <div className="space-y-10">

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">1. Allgemeine Hinweise</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften, insbesondere der Datenschutz-Grundverordnung DSGVO, sowie dieser Datenschutzerkl\u00e4rung."}</p>
                <p>{"Personenbezogene Daten sind alle Daten, mit denen Sie pers\u00f6nlich identifiziert werden k\u00f6nnen."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">2. Verantwortlicher</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Verantwortlicher f\u00fcr die Datenverarbeitung auf dieser Website ist:"}</p>
                <div className="space-y-1">
                  <p className="text-foreground font-semibold">Bauunternehmung Freitag GmbH</p>
                  <p>Hinter dem Turme 29</p>
                  <p>38114 Braunschweig</p>
                  <p>Deutschland</p>
                </div>
                <div className="space-y-1">
                  <p>Vertreten durch:</p>
                  <p>{"Gesch\u00e4ftsf\u00fchrer Uwe Freitag"}</p>
                  <p>Dipl. Immobilienwirt (EIA), Bautechniker</p>
                </div>
                <div className="space-y-1">
                  <p>Telefon: +49 (0) 531 87 46 10</p>
                  <p>E-Mail: info@freitag-bs.de</p>
                </div>
                <p>{"Diese Datenschutzerkl\u00e4rung gilt f\u00fcr die Website der Freitag-Gruppe mit den T\u00e4tigkeitsbereichen Bauunternehmung, Garten- und Landschaftsbau sowie Sachverst\u00e4ndigenb\u00fcro."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">{"3. Hosting \u00fcber Vercel"}</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Diese Website wird \u00fcber Vercel bereitgestellt. Beim Aufruf dieser Website verarbeitet Vercel technische Informationen, die erforderlich sind, um die Website auszuliefern und die Sicherheit sowie Stabilit\u00e4t des Betriebs zu gew\u00e4hrleisten."}</p>
                <p>{"Dazu k\u00f6nnen insbesondere folgende Daten geh\u00f6ren:"}</p>
                <ul className="list-disc list-inside space-y-1 pl-2">
                  <li>IP-Adresse</li>
                  <li>Datum und Uhrzeit des Zugriffs</li>
                  <li>Browserinformationen</li>
                  <li>Betriebssystem</li>
                  <li>Referrer-URL</li>
                  <li>angeforderte Inhalte</li>
                </ul>
                <p>{"Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der sicheren, schnellen und effizienten Bereitstellung unserer Website."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">4. Domainregistrierung und E-Mail</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Die Domainregistrierung sowie Teile der E-Mail-Kommunikation k\u00f6nnen \u00fcber externe technische Dienstleister erfolgen. Im Rahmen der technischen Bereitstellung und Kommunikation k\u00f6nnen personenbezogene Daten verarbeitet werden."}</p>
                <p>{"Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Soweit es um konkrete Kommunikation, Anfragen oder eine m\u00f6gliche Vertragsanbahnung geht, erfolgt die Verarbeitung zus\u00e4tzlich auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">5. Kontaktaufnahme per E-Mail oder Telefon</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Wenn Sie uns per E-Mail oder Telefon kontaktieren, verarbeiten wir die von Ihnen mitgeteilten Daten zur Bearbeitung Ihrer Anfrage und f\u00fcr den Fall von Anschlussfragen."}</p>
                <p>Dies betrifft insbesondere:</p>
                <ul className="list-disc list-inside space-y-1 pl-2">
                  <li>Name</li>
                  <li>Kontaktdaten</li>
                  <li>Inhalt der Nachricht</li>
                  <li>{"sonstige von Ihnen \u00fcbermittelte Informationen"}</li>
                </ul>
                <p>{"Die Verarbeitung erfolgt zur Durchf\u00fchrung vorvertraglicher Ma\u00dfnahmen oder zur Bearbeitung Ihrer Anfrage auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Soweit keine vorvertragliche Kommunikation vorliegt, erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO aufgrund unseres berechtigten Interesses an einer effizienten Bearbeitung eingehender Anfragen."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">6. Kontaktformular und E-Mail-Versand</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Wenn Sie uns \u00fcber das Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular einschlie\u00dflich der dort angegebenen Kontaktdaten zum Zweck der Bearbeitung der Anfrage und f\u00fcr den Fall von Anschlussfragen verarbeitet."}</p>
                <p>{"Dabei k\u00f6nnen insbesondere folgende Daten verarbeitet werden:"}</p>
                <ul className="list-disc list-inside space-y-1 pl-2">
                  <li>Name</li>
                  <li>E-Mail-Adresse</li>
                  <li>Telefonnummer, sofern angegeben</li>
                  <li>Inhalt der Nachricht</li>
                  <li>technische Metadaten des Versandvorgangs</li>
                </ul>
                <p>{"F\u00fcr den Versand bzw. die technische \u00dcbermittlung der \u00fcber das Kontaktformular abgesendeten Nachrichten kann ein externer E-Mail-Dienstleister eingesetzt werden."}</p>
                <p>{"Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, soweit Ihre Anfrage auf den Abschluss eines Vertrags gerichtet ist oder der Durchf\u00fchrung vorvertraglicher Ma\u00dfnahmen dient. Im \u00dcbrigen erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">{"7. Cookies und \u00e4hnliche Technologien"}</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Unsere Website verwendet Cookies und vergleichbare Technologien. Cookies sind kleine Textdateien, die auf Ihrem Endger\u00e4t gespeichert werden und bestimmte Informationen enthalten."}</p>
                <p>Wir unterscheiden zwischen:</p>
                <div className="pl-4 space-y-3">
                  <div>
                    <p className="text-foreground font-semibold">Technisch notwendigen Cookies</p>
                    <p>{"Diese Cookies sind erforderlich, um die Website sicher und funktionsf\u00e4hig bereitzustellen oder von Ihnen ausdr\u00fccklich gew\u00fcnschte Funktionen umzusetzen."}</p>
                  </div>
                  <div>
                    <p className="text-foreground font-semibold">{"Einwilligungsbed\u00fcrftigen Cookies bzw. Technologien"}</p>
                    <p>{"Diese dienen insbesondere Statistik-, Analyse-, Marketing- oder Komfortzwecken und werden nur gesetzt bzw. aktiviert, wenn Sie ausdr\u00fccklich eingewilligt haben."}</p>
                  </div>
                </div>
                <p>{"F\u00fcr technisch notwendige Cookies erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO sowie nach den gesetzlichen Vorschriften f\u00fcr technisch notwendige Speicherungen und Zugriffe auf Endger\u00e4te. F\u00fcr alle nicht notwendigen Cookies und Tracking-Technologien erfolgt der Einsatz nur mit Ihrer Einwilligung."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">8. Consent-Management / Cookie-Banner</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Unsere Website verwendet ein Consent-Management-Tool, um Ihre Einwilligungen f\u00fcr bestimmte Cookies und Tracking-Technologien einzuholen, zu speichern und zu verwalten."}</p>
                <p>{"Dabei wird ein Cookie oder ein lokaler Eintrag gespeichert, in dem Ihre Auswahl dokumentiert wird. Dieser Nachweis dient dazu, Ihre Entscheidung beim erneuten Besuch der Website zu ber\u00fccksichtigen und datenschutzrechtliche Nachweispflichten zu erf\u00fcllen."}</p>
                <p>{"Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO, soweit die Speicherung der Einwilligungsentscheidung zur Erf\u00fcllung rechtlicher Verpflichtungen erforderlich ist. Erg\u00e4nzend erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO aufgrund unseres berechtigten Interesses an einer rechtssicheren Steuerung eingesetzter Technologien."}</p>
                <p>{"Sie k\u00f6nnen Ihre Einwilligung jederzeit mit Wirkung f\u00fcr die Zukunft \u00fcber die auf der Website bereitgestellten Cookie-Einstellungen \u00e4ndern oder widerrufen."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">9. Google Analytics</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Soweit Sie ausdr\u00fccklich eingewilligt haben, nutzen wir auf dieser Website Google Analytics, einen Webanalysedienst von Google, zur Auswertung des Nutzerverhaltens und zur statistischen Verbesserung unseres Onlineangebots."}</p>
                <p>{"Google Analytics kann dabei insbesondere folgende Informationen verarbeiten:"}</p>
                <ul className="list-disc list-inside space-y-1 pl-2">
                  <li>aufgerufene Seiten</li>
                  <li>{"technische Informationen zu Browser und Endger\u00e4t"}</li>
                  <li>{"ungef\u00e4hre Standortdaten"}</li>
                  <li>Nutzungsdauer und Interaktionen</li>
                  <li>Referrer-Informationen</li>
                </ul>
                <p>{"Google Analytics wird auf dieser Website nicht ohne Ihre Einwilligung geladen. Die Einbindung erfolgt erst nach Zustimmung \u00fcber das Cookie-Banner. Ohne Einwilligung wird kein Analytics-Skript geladen."}</p>
                <p>{"Die Verarbeitung erfolgt ausschlie\u00dflich auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO."}</p>
                <p>{"Sie k\u00f6nnen eine bereits erteilte Einwilligung jederzeit mit Wirkung f\u00fcr die Zukunft \u00fcber die Cookie-Einstellungen widerrufen."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">{"10. Drittland\u00fcbermittlungen"}</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Im Rahmen der Nutzung einzelner Dienstleister kann eine \u00dcbermittlung personenbezogener Daten in Staaten au\u00dferhalb der Europ\u00e4ischen Union bzw. des Europ\u00e4ischen Wirtschaftsraums, insbesondere in die USA, stattfinden."}</p>
                <p>{"F\u00fcr \u00dcbermittlungen in die USA kann das EU-U.S. Data Privacy Framework relevant sein, sofern der jeweilige Anbieter entsprechend zertifiziert ist. Die Europ\u00e4ische Kommission hat am 10. Juli 2023 einen Angemessenheitsbeschluss f\u00fcr das EU-U.S. Data Privacy Framework angenommen."}</p>
                <p>{"Daneben k\u00f6nnen je nach Anbieter erg\u00e4nzende vertragliche Schutzmechanismen, insbesondere Standardvertragsklauseln, eingesetzt werden."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">11. Auftragsverarbeitung</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Soweit wir Dienstleister einsetzen, die personenbezogene Daten in unserem Auftrag verarbeiten, schlie\u00dfen wir mit diesen \u2013 soweit erforderlich \u2013 Vertr\u00e4ge zur Auftragsverarbeitung gem\u00e4\u00df Art. 28 DSGVO ab."}</p>
                <p>{"Dies kann insbesondere Dienstleister f\u00fcr Hosting, Domainverwaltung, E-Mail-Kommunikation und technische Formular\u00fcbermittlung betreffen."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">12. Speicherdauer</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Wir speichern personenbezogene Daten nur so lange, wie dies f\u00fcr die jeweiligen Verarbeitungszwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen."}</p>
                <p>{"Kontaktanfragen speichern wir grunds\u00e4tzlich nur so lange, wie dies zur Bearbeitung der Anfrage und etwaiger Anschlusskommunikation erforderlich ist, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen."}</p>
                <p>{"Einwilligungsdaten aus dem Consent-Management werden so lange gespeichert, wie dies zur Nachweisf\u00fchrung und technischen Steuerung erforderlich ist."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">13. Ihre Rechte</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>Sie haben im Rahmen der gesetzlichen Vorschriften das Recht:</p>
                <ul className="list-disc list-inside space-y-1 pl-2">
                  <li>{"auf Auskunft \u00fcber Ihre bei uns gespeicherten personenbezogenen Daten, Art. 15 DSGVO"}</li>
                  <li>{"auf Berichtigung unrichtiger oder Vervollst\u00e4ndigung unvollst\u00e4ndiger Daten, Art. 16 DSGVO"}</li>
                  <li>{"auf L\u00f6schung Ihrer bei uns gespeicherten Daten, Art. 17 DSGVO"}</li>
                  <li>{"auf Einschr\u00e4nkung der Verarbeitung, Art. 18 DSGVO"}</li>
                  <li>{"auf Daten\u00fcbertragbarkeit, Art. 20 DSGVO"}</li>
                  <li>auf Widerspruch gegen die Verarbeitung, Art. 21 DSGVO</li>
                  <li>{"auf Widerruf erteilter Einwilligungen mit Wirkung f\u00fcr die Zukunft, Art. 7 Abs. 3 DSGVO"}</li>
                </ul>
                <p>{"Zur Aus\u00fcbung Ihrer Rechte gen\u00fcgt eine formlose Mitteilung an die oben genannten Kontaktdaten."}</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">{"14. Beschwerderecht bei einer Aufsichtsbeh\u00f6rde"}</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Sie haben das Recht, sich bei einer Datenschutzaufsichtsbeh\u00f6rde \u00fcber die Verarbeitung Ihrer personenbezogenen Daten zu beschweren."}</p>
                <p>{"Zust\u00e4ndige Datenschutzaufsichtsbeh\u00f6rde in Niedersachsen ist:"}</p>
                <div className="space-y-1">
                  <p className="text-foreground font-semibold">{"Die Landesbeauftragte f\u00fcr den Datenschutz Niedersachsen"}</p>
                  <p>{"Prinzenstra\u00dfe 5"}</p>
                  <p>30159 Hannover</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">{"15. SSL- bzw. TLS-Verschl\u00fcsselung"}</h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-3">
                <p>{"Diese Website nutzt aus Sicherheitsgr\u00fcnden und zum Schutz der \u00dcbertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschl\u00fcsselung. Dadurch k\u00f6nnen Daten, die Sie an uns \u00fcbermitteln, nicht ohne Weiteres von Dritten mitgelesen werden."}</p>
              </div>
            </section>

          </div>
        </motion.div>
      </div>
    </div>
  );
}
